import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { BarChartData } from '../../../shared/models/charts/chart-data-types';
import { BarChartConfig } from '../../../shared/models/charts/chart-config-types';
import { ReusableStreamProperty } from '@ipreo/muni-shared';
import { GameDayViewType } from '../../../state/data/state';
import { NegativeCasesService } from '../../services/negative-cases.service';
import { ProgressBarChartService } from './progress-bar-chart.service';

const GAMEDAY_CHART_CONFIG = {
  axis: {
    y: {
      formatter: d => d / 1000000,
      display: true,
      units: '$Mn',
      ticks: 5
    }
  },
  margin: {
    top: 10,
    bottom: 15
  },
  duration: 300
};

@Component({
  providers: [ProgressBarChartService],
  selector: 'muni-gameday-progress-bar-chart',
  templateUrl: './progress-bar-chart.template.html',
  styleUrls: ['./progress-bar-chart.styles.scss'],
  standalone: false,
})
export class ProgressBarChartComponent {
  @Input()
  loading: Observable<boolean>;

  @ReusableStreamProperty
  public readonly emptyChartMessage: Observable<
    string
  > = this.negativeCasesService.messages.pipe(
    map(messages => messages.chart),
    distinctUntilChanged()
  );

  public viewType: Observable<GameDayViewType> = this.progressBarChartService
    .viewType;
  public chartObservable: Observable<BarChartData> = this
    .progressBarChartService.chartData;
  public config: BarChartConfig = GAMEDAY_CHART_CONFIG;
  public viewTypes = GameDayViewType;

  constructor(
    private progressBarChartService: ProgressBarChartService,
    private negativeCasesService: NegativeCasesService
  ) {}

  public priorityType(): void {
    this.progressBarChartService.setViewType(GameDayViewType.PriorityType);
  }

  public retailType(): void {
    this.progressBarChartService.setViewType(GameDayViewType.RetailType);
  }

  public managerType(): void {
    this.progressBarChartService.setViewType(GameDayViewType.ManagersType);
  }

  public moneyType(): void {
    this.progressBarChartService.setViewType(GameDayViewType.MoneyType);
  }

  public handleEvents(event: { type: string; payload: any }): void {
    this.progressBarChartService.handleEvents(event);
  }
}
